module.exports = __webpack_public_path__ + "static/img/Servicetrade.504e2a80.png";